import { render, staticRenderFns } from "./BranchTimeDelete.vue?vue&type=template&id=3ffca8a2&scoped=true&"
import script from "./BranchTimeDelete.vue?vue&type=script&lang=js&"
export * from "./BranchTimeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffca8a2",
  null
  
)

export default component.exports